module.exports = __webpack_public_path__ + "media/durango/dgo_gob_sec_edu-178f2e7b.png";